import { render } from "./XIconSolidBrandParsinta.vue?vue&type=template&id=23246ec0"
import script from "./XIconSolidBrandParsinta.vue?vue&type=script&lang=js"
export * from "./XIconSolidBrandParsinta.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidBrandParsinta.vue"]])

export default __exports__